import VehicleHero from 'assets/images/psp/hero/vehicle-hero.webp';
import pavedSurfaceIcon from 'assets/images/psp/amenities/paved-surfaces.svg';
import cameraIcon from 'assets/images/icons/psp/camera.svg';
import garageIcon from 'assets/images/psp/amenities/garage.svg';
import twentyFourHourIcon from 'assets/images/psp/amenities/24-hour.svg';
import paperIcon from 'assets/images/psp/amenities/paperwork.svg';
import Vehicle1 from 'assets/images/psp/FeaturedImages/kayakFeatured1.webp';
import Vehicle2 from 'assets/images/psp/FeaturedImages/car2.webp';
import Vehicle3 from 'assets/images/psp/FeaturedImages/motorcycle1.webp';
import Vehicle4 from 'assets/images/psp/FeaturedImages/atv-1.webp';
const reviews = [
	{
		reviewTitle: 'Easy to register and the first month is free',
		reviewRating: 5,
		reviewText:
			"Easy to register and first month was free. The unit is clean and easy to maneuver my classic car in and out. And it's climate-controlled!",
		reviewerInitials: 'CU',

		reviewerName: 'CustomerBill',
		reviewDate: 'December 23, 2024',
		link: 'https://www.trustpilot.com/reviews/676941d937311529e3c8e617',
	},
	{
		reviewTitle: 'Super easy and relaxing experience!',
		reviewRating: 5,
		reviewText:
			"It was easy to find a location I needed, and once I sent my request, the gal called me that evening and was super friendly. I've been stressed about finding a place to store my car between visits, and this experience made it so easy, and now I can relax!",
		reviewerInitials: 'MP',

		reviewerName: 'Marcia Pierce-rasmussen',
		reviewDate: 'October 25, 2023',
		link: 'https://www.trustpilot.com/users/5c9c3158bce74c6ce8c431c2',
	},
	{
		reviewTitle: 'Very helpful',
		reviewRating: 5,
		reviewText:
			'Very helpful. I needed a storage space for my car that had to be a drive-up and climate-controlled, and 10x20. Efficient searching and found exactly what I was looking for, and held it for me.',
		reviewerInitials: 'BD',

		reviewerName: 'Blaine Dyson',
		reviewDate: 'October 4, 2022',
		link: 'https://www.trustpilot.com/reviews/633b51913d107cfdfcd20911',
	},
	{
		reviewTitle: 'Excellent Place to Look for Vehicle Storage',
		reviewRating: 5,
		reviewText:
			'This was a great place to look for local storage for my vehicle, which was a sports car for the summer. They were able to find me the closest and cheapest storage, which is not easy. They also provide terms and costs, so it was no surprise when I signed up.',
		reviewerInitials: 'DY',

		reviewerName: 'David W. Young',
		reviewDate: 'September 10, 2022',
		link: 'https://www.trustpilot.com/reviews/631b74886a3e1ed2c3ce9c14',
	},
];

const faqs = [
	{
		question: 'How much does vehicle storage cost per month?',
		answer: 'Vehicle storage rates range from $51.47/month for a 5×10 (motorcycles, jet skis) to $165.85/month for a 10×30 (RVs, large boats), with pricing varying by location and unit size.',
	},
	{
		question:
			"What's the difference between parking storage units and regular storage?",
		answer: 'Parking storage units are specifically designed for vehicles with wider driveways, taller doors, and paved surfaces, while regular storage is optimized for household goods.',
	},
	{
		question: 'Do I need insurance for vehicle storage?',
		answer: 'Your auto insurance may cover storage, but verify with your provider—many storage facility parking locations offer supplemental coverage options.',
	},
	{
		question: 'Can I access my vehicle anytime?',
		answer: 'Most vehicle storages near me offer 24-hour access with gate codes, though some facilities have limited hours—always confirm before renting.',
	},
	{
		question: 'What documents do I need for vehicle storage?',
		answer: "Bring valid registration, proof of insurance, driver's license, and vehicle title—most facilities require the vehicle to be operable and legally registered.",
	},
	{
		question: 'How do I prepare my car for long-term vehicle storage?',
		answer: 'Change fluids, fill the gas tank with stabilizer, disconnect the battery, check tire pressure, and use a quality car cover to protect your vehicle during storage.',
	},
	{
		question: 'What size unit do I need for an RV?',
		answer: "RV storage typically requires 10×30 for smaller campers up to 12×35 or 14×45 for Class A motorhomes—measure your RV's total length and add 2-3 feet clearance.",
	},
];

export const VehicleContent = {
	type: 'Vehicle',
	sections: [
		{
			title: 'Vehicle Storage',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'vehicle-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Vehicle Storage For You',
							description:
								"Your garage is full, your driveway is maxed out, and that boat, [classic car](https://www.sparefoot.com/blog/store-luxury-car), or extra vehicle needs a home. Whether you're storing a daily driver during a deployment, protecting a collector car for the winter, or [parking an RV between adventures](https://www.sparefoot.com/blog/rv-storage-size-guide), vehicle storage gives you the space you need without the premium cost of a larger garage or the headaches of street parking. From basic outdoor parking storage units to premium enclosed spaces, SpareFoot helps you compare vehicle storage rates and find parking storage units that fit your budget and protection needs.",
							image: VehicleHero,
							CTAText: 'Compare Rates & Reserve Online',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Vehicle Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Vehicle Storage',
			modules: [
				{
					type: 'content',
					id: 'vehicle-storage-content',
					props: {
						contentType: 'row-type',
						title: 'What Can You Store?',
						ShowBackgroundImage: false,
						content: [
							'SpareFoot connects customers like you to thousands of local vehicle storage facilities, offering an array of vehicle storage unit sizes and amenities to fit your needs and budget.',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Vehicle Storage Type',
								key: 'Vehicle Storage Type',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Vehicle Storage Type': 'Cars & Trucks',
								'Best For':
									"Classic cars, project vehicles, seasonal vehicles, or extra family cars that don't fit in your garage",
							},
							{
								'Vehicle Storage Type': 'Motorcycles & ATVs',
								'Best For':
									'Protect your bike from weather and theft during off-season months or while traveling.',
							},
							{
								'Vehicle Storage Type': 'Boats & Watercraft',
								'Best For':
									'From small fishing boats to larger cabin cruisers, storage facility parking keeps your vessel safe and ready.',
							},
							{
								'Vehicle Storage Type': 'RVs & Campers',
								'Best For':
									'Class A motorhomes, travel trailers, and campers need secure parking between trips—avoid HOA violations and neighborhood complaints.',
							},
							{
								'Vehicle Storage Type':
									'Work Vehicles & Trailers',
								'Best For':
									'Contractors, landscapers, and small business owners can store work trucks, cargo trailers, and equipment conveniently.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Vehicle Storage Unit Size Guide: Most Popular Storage Dimensions',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						title: 'Vehicle Storage Unit Size Guide: Most Popular Storage Dimensions',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Average Monthly Rate',
								key: 'Average Monthly Rate',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
						],
						rows: [
							{
								'Unit Size': '5×10',
								'Average Monthly Rate': '$51.47',
								'What Fits':
									'Motorcycle, jet ski, small equipment',
							},
							{
								'Unit Size': '10×10',
								'Average Monthly Rate': '$82.81',
								'What Fits':
									'Motorcycle, ATV, small boat with trailer',
							},
							{
								'Unit Size': '10×15',
								'Average Monthly Rate': '$109.48',
								'What Fits':
									'Compact car, small boat (16-20 ft), work trailer',
							},
							{
								'Unit Size': '10×20',
								'Average Monthly Rate': '$132.43',
								'What Fits':
									'Standard car, sedan, small truck, medium boat',
							},
							{
								'Unit Size': '10×25',
								'Average Monthly Rate': 'Contact for pricing',
								'What Fits':
									'SUV, pickup truck, larger boat (20-25 ft)',
							},
							{
								'Unit Size': '10×30',
								'Average Monthly Rate': '$165.85',
								'What Fits':
									'Large truck, RV, cabin cruiser, multiple motorcycles',
							},
							{
								'Unit Size': '12×35 to 14×45',
								'Average Monthly Rate': 'Contact for pricing',
								'What Fits':
									'Class A motorhome, large RV, oversized boat',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						title: '',
						ShowBackgroundImage: false,
						content: [
							'*Vehicle storage rates based on average pricing across SpareFoot.com facilities in the United States*.\n\n',
						],
					},
				},
			],
		},

		{
			title: 'content',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						title: '',
						ShowBackgroundImage: false,
						content: [
							'### Choosing the Right Size for Vehicle Storage\n\n' +
								'- **Cars & Sedans:** 10×20 provides adequate space with room to walk around\n\n' +
								'- **Trucks & SUVs:** 10×25 or larger accommodates larger vehicles with door clearance\n\n' +
								'- **Motorcycles:** 5×10 or shared 10×10 spaces work perfectly\n\n' +
								'- **Small Boats (16-20 ft):** 10×20 to 10×25 with trailer clearance\n\n' +
								'- **Large Boats (20-30 ft):** 10×30 or larger, depending on beam width\n\n' +
								'- **RVs & Motorhomes:** 10×30 to 14×45 depending on class and length',
							"**Pro Tip:** Always measure your vehicle's total length, including hitches, mirrors, and any accessories, before selecting storage facility parking spaces.",
						],
					},
				},
			],
		},

		{
			title: 'Preparing Your Vehicle for Storage',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						title: 'Preparing Your Vehicle for Storage',
						ShowBackgroundImage: false,
						content: [
							'Follow these quick steps to prepare your vehicle for storage, so your ride is ready to go whenever you are.',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Preparation Step',
								key: 'Preparation Step',
							},
							{
								label: 'Why It Matters',
								key: 'Why It Matters',
							},
						],
						rows: [
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Change fluids**',
								},
								'Why It Matters':
									'Fresh oil prevents corrosion; a full gas tank with stabilizer prevents condensation',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Clean thoroughly**',
								},
								'Why It Matters':
									'Remove food and debris that attract pests; it prevents mold in enclosed spaces',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Check tire pressure**',
								},
								'Why It Matters':
									'Maintain proper PSI or use jack stands to prevent flat spots',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Disconnect battery**',
								},
								'Why It Matters': {
									type: 'markdown',
									markdown:
										'Prevents drainage; store separately or use a [trickle charger in the garage rental space with electricity](https://www.sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries)',
								},
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Use a cover**',
								},
								'Why It Matters':
									'Protects paint and interior from dust, sun, and moisture',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Add pest deterrents**',
								},
								'Why It Matters':
									'Seal openings; place dryer sheets to deter rodents',
							},
						],
					},
				},
			],
		},
		{
			title: 'Vehicle Storage Amenities',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Makes Good Vehicle Storage?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: 'vehicle-amenities-section',
						headerLink: '#vehicle-amenities-section',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: cameraIcon,
								content:
									'#### Security Features\n\n' +
									'Gated access, surveillance cameras, and well-lit premises protect your investment from theft and vandalism.\n\n',
								newlayout: false,
							},
							{
								image: garageIcon,
								content:
									'#### Wide Driveways & Turning Radius\n\n' +
									'Essential for maneuvering larger vehicles, boats, and RVs without scraping or damage.\n\n',
								newlayout: false,
							},
							{
								image: pavedSurfaceIcon,
								content:
									'#### Paved Surfaces\n\n' +
									'Prevents mud, standing water, and uneven ground that could damage tires or cause vehicle settling.\n\n',
								newlayout: false,
							},
							{
								image: twentyFourHourIcon,
								content:
									'#### Convenient Access Hours\n\n' +
									"24-hour access means retrieving your vehicle on your schedule, not the facility's.\n\n",
								newlayout: false,
							},
							{
								image: paperIcon,
								content:
									'#### Insurance Options \n\n' +
									'Verify your auto insurance covers storage, or purchase facility insurance to protect stored vehicles.',
								newlayout: false,
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			modules: [
				{
					type: 'reviews',
					props: {
						slug: 'vehicle-reviews',
						title: 'What SpareFoot Customers Have to Say About Our Vehicle Storage Search',
						reviews: reviews,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Vehicle Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'vehicle-featured-content',
						contentCards: [
							{
								title: 'How to Find The Right Storage Facility For Your Car, RV, or Boat',
								date: 'October 24, 2025',
								image: Vehicle1,
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
								link: 'https://www.sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat',
							},
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: Vehicle2,
								content:
									'Protect Your Ride: Long-term Motorcycle Storage Tips',
								link: 'https://sparefoot.com/blog/car-storage-size-guide',
							},
							{
								title: 'Protect Your Ride: Long-term Motorcycle Storage Tips',
								date: 'September 22, 2025',
								image: Vehicle3,
								content:
									'Protect Your Ride: Long-term Motorcycle Storage Tips',
								link: 'https://sparefoot.com/blog/how-to-winterize-and-store-your-motorcycle',
							},
							{
								title: 'Complete ATV Winterization Guide: How to Store Your ATV for Winter',
								date: 'October 2, 2025',
								image: Vehicle4,
								content:
									'Complete ATV Winterization Guide: How to Store Your ATV for Winter',
								link: 'https://www.sparefoot.com/blog/atv-winterization-guide',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Car',
							'RV',
							'Boat',
							'Motorcycle',
							'ClimateControl',
							'DriveUp',
							'24Hour',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
